export default __webpack_public_path__ + "static/media/volks.6e54e578.jpg";